export default "__VITE_ASSET__Ve6rs3oH__"